import React from 'react';
import { AppBar, Avatar, Badge, styled } from '@mui/material';
import { Menu as MenuIcon, NotificationsOutlined } from '@mui/icons-material';
import { Colors } from 'library';
import TandemLogo from 'assets/images/NavyLogo.svg';

export function RLayoutTopBar({ small, onToggleSidebar }: { small: boolean; onToggleSidebar: () => void }) {
    return (
        <StyledAppBar position="fixed">
            <Bar small={small}>
                <LeftSection>
                    <TandemLogo htmlColor={Colors.darkNavy} style={{ height: 72, width: 72 }} />
                    {small && (
                        <MenuButton onClick={onToggleSidebar} aria-label="toggle sidebar">
                            <MenuIcon sx={{ color: Colors.darkNavy, fontSize: 22 }} />
                        </MenuButton>
                    )}
                </LeftSection>
                <RightSection>
                    <Badge badgeContent={2} color="error" overlap="circular">
                        <NotificationsOutlined sx={{ color: Colors.darkNavy, fontSize: 24 }} />
                    </Badge>
                    <UserAvatar>MM</UserAvatar>
                </RightSection>
            </Bar>
        </StyledAppBar>
    );
}

const StyledAppBar = styled(AppBar)({
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    backgroundColor: Colors.white,
    zIndex: 1201,
});

const Bar = styled('div')<{ small: boolean }>(({ small }) => ({
    alignItems: 'center',
    display: 'flex',
    height: small ? 50 : 60,
    justifyContent: 'space-between',
    padding: '0 16px',
}));

const LeftSection = styled('div')({
    alignItems: 'center',
    display: 'flex',
    gap: 8,
});

const RightSection = styled('div')({
    alignItems: 'center',
    display: 'flex',
    gap: 16,
});

const MenuButton = styled('button')({
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 4,
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
        backgroundColor: Colors.lightGrey,
    },
});

const UserAvatar = styled(Avatar)({
    width: 36,
    height: 36,
    fontSize: 14,
    fontWeight: 600,
    backgroundColor: Colors.darkNavy,
    color: Colors.white,
    cursor: 'pointer',
});
